import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_active_outbound_shipments_by_order_extendedService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { order_id: number, full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: number, lookup_code?: string }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { order_id?: number, full_text_search?: string, $keys: number[] }): Promise<{ result?: { id?: number, lookup_code?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      order_id: number, full_text_search?: string    }) {
        if(isNil($inParams.order_id)) {
          return true; 
        }
      return false;
    }
}
